import {
    CONTACT,
    IMAGES_FROM_EVENTS,
    JOIN_OUR_TEAM,
    OUR_LEAGUE,
    OUR_TEAM,
    SECOND__LEAGUE,
    SPONSORS,
    TERMS,
    YOUR_CARRIER
} from "../Routes";
import {useTranslation} from "react-i18next";
import {faFacebook, faInstagram} from "@fortawesome/free-brands-svg-icons";
import {
    faAddressCard,
    faHandHoldingDollar,
    faImage,
    faMedal,
    faPeopleGroup,
    faRightToBracket,
    faScaleBalanced,
    faStairs,
    faUserPlus
} from "@fortawesome/free-solid-svg-icons";
import {useNavigate} from "react-router-dom";
import {useContext} from "react";
import {ANIMATION__CONTEXT} from "../AnimationContext";
import {faLandmark} from "@fortawesome/pro-solid-svg-icons";

const usePageContent = () => {

    const {t} = useTranslation()

    const navigate = useNavigate()

    const [_, setIsAnimationOn] = useContext<any>(ANIMATION__CONTEXT)

    const singUpForEvent = () => {
        window.open('https://martialmatch.com/pl/events/406-acl-2-amateur-combat-league-', '_blank')
    }

    const BuyTicket = () => {
        window.open('https://acl-fight.mk-events.pl/rejestracja', '_blank')
    }


    const handleAnimation = () => {
        setIsAnimationOn(true)
        setTimeout(() => {
            setIsAnimationOn(false)
        }, 1200)
    }

    // FirstImages
    const imagesList = [
        {
            title: t(''),
            link: 'https://acl-fight.mk-events.pl/rejestracja',
            image: window.location.origin + '/baner_ACL2.jpeg'
        },
    ]
    //UPCOMMINGEVENT
    const upComingEvent = {
        eventName: t('lbl_second_edition_alc'),
        eventWeekDay: t('lbl_saturday'),
        eventData: '30.11.2024',
        eventLocation: 'Aleja Ignacego Jana Paderewskiego 35 Hala Wielofunkcyjna AWF, 51-612 Wrocław',
        eventTime: '9:00',
        weightingTime: '20:00'
    }
    const upcomingEventOptions = [
        {
            label: t('lbl_sign_in'),
            action: singUpForEvent
        },
        {
            label: t('lbl_buy_ticket'),
            action: BuyTicket
        },
        {
            label: t('lbl_learn_more'),
            action: () => {
                handleAnimation()
                setTimeout(() => {
                    window.scroll(0, 0)
                    navigate(OUR_LEAGUE)
                }, 400)
            }
        }
    ]
    //GENERAL
    const language = [
        {
            image: 'https://upload.wikimedia.org/wikipedia/en/thumb/1/12/Flag_of_Poland.svg/1200px-Flag_of_Poland.svg.png',
            code: 'pl',
            label: 'Polski'
        },
        {
            image: 'https://upload.wikimedia.org/wikipedia/commons/thumb/a/a5/Flag_of_the_United_Kingdom_%281-2%29.svg/1200px-Flag_of_the_United_Kingdom_%281-2%29.svg.png',
            code: 'en',
            label: 'English'
        },
        {
            image: 'https://upload.wikimedia.org/wikipedia/commons/c/cb/Flag_of_the_Czech_Republic.svg',
            code: 'cz',
            label: 'Ceština'
        },
        {
            image: 'https://upload.wikimedia.org/wikipedia/commons/b/ba/Flag_of_Germany.svg',
            code: 'de',
            label: 'Deutsch'
        },
        {
            image: 'https://itro.pl/wp-content/uploads/2020/01/ukrainaflaga.png',
            code: 'ua',
            label: 'українська'
        },


    ]
    //SPONSOR
    const sponsorsData: any = {
        gold: [
            {
                image: window.location.origin + '/mgn_sponsor.png',
                link: ''
            },
            {
                image: window.location.origin + '/mbeaty_logo.jpeg',
                link: ''
            },
            {
                image: window.location.origin + '/unique_logo.jpeg',
                link: ''
            },
            {
                image: window.location.origin + '/platinum-sponsor.png',
                link: ''
            },
            {
                image: window.location.origin + '/wincom-sponsor.JPG',
                link: ''
            },
            {
                image: window.location.origin + '/arkada_sponsor.png',
                link: ''
            },
        ],
        other: [
            {
                image: 'data:image/png;base64,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',
                link: ''
            },
            {
                image: window.location.origin + '/OFP_LOGO.png',
                link: ''
            },
            {
                image: 'https://fightclubchampion.pl/wp-content/uploads/2021/07/logo_FCCW_invert.png',
                link: ''
            },

            {
                image: window.location.origin + '/hybrid_mma_logo.jpeg',
                link: ''
            },
            {
                image: window.location.origin + '/cherry_logo.png',
                link: ''
            },
            {
                image: window.location.origin + '/Babilon_mma_logo.jpeg',
                link: ''
            },
        ]
    }
    const sponsorMail = 'acl.fight@gmail.com'
    //NAVIGATION
    const MG_LEAGUE = [
        {
            title: t('lbl_our_squad'),
            icon: faPeopleGroup,
            navigation: OUR_TEAM,
        },
        {
            title: t('lbl_our_league'),
            icon: faMedal,
            navigation: OUR_LEAGUE,
        },
        {
            title: t('lbl_contact_us'),
            icon: faAddressCard,
            navigation: CONTACT
        },
    ]
    const competition = [

        {
            title: t('lbl_photos_from_leagues'),
            icon: faImage,
            navigation: IMAGES_FROM_EVENTS
        },
        {
            title: t('lbl_your_carrier_with_acl'),
            icon: faStairs,
            navigation: YOUR_CARRIER
        },
        {
            title: t('lbl_terms'),
            icon: faScaleBalanced,
            navigation: TERMS
        },
    ]
    const cooperation = [
        {
            title: t('lbl_become_sponsor'),
            icon: faHandHoldingDollar,
            navigation: SPONSORS
        },
        {
            title: t('lbl_join_our_team'),
            icon: faUserPlus,
            navigation: JOIN_OUR_TEAM
        },
    ]
    const headerOptions = [
        {
            title: 'ACL 2',
            icon: faLandmark,
            isCustom: true,
            underSections: [],
            customAction: () => {
                handleAnimation()
                setTimeout(() => {
                    window.scroll(0, 0)
                    navigate(SECOND__LEAGUE)
                }, 400)
            }

        },
        {
            title: t('lbl_sign_in'),
            isCustom: true,
            underSections: [],
            icon: faRightToBracket,
            customAction: singUpForEvent,
        },
        {
            title: t('lbl_us'),
            underSections: MG_LEAGUE
        },
        {
            title: t('lbl_competition'),
            underSections: competition
        },
        {
            title: t('lbl_cooperation'),
            underSections: cooperation
        },


    ]
    //CONTACT
    const contactValues: any = {
        phone: [
            '+48 798 336 840'
        ],
        mail: [
            'acl.fight@gmail.com'
        ]
    }
    //OURTEAM
    const outTeamSections = [
        {
            name: 'Mateusz Gląb',
            title: t('lbl_founder'),
            image: window.location.origin + '/mateusz-g.jpeg',
            description: t('lbl_mateusz_g_desc')
        },
        {
            name: 'Mateusz Augustyniak',
            title: t('lbl_founder'),
            image: window.location.origin + '/mateusz-a.jpg',
            description: t('lbl_mateusz_a_desc')
        },
        {
            name: 'Kacper Orłowski',
            title: t('lbl_referee'),
            image: window.location.origin + '/kacper_sedzia.jpeg',
            description: t('lbl_kacper_ref_desc')
        },
    ]
    //OURLEAGUE
    const ourLeague = {
        image: window.location.origin + '/zdj-2-strona-glowna.jpg',
        description: t('lbl_our_league_desc'),
        questions: [
            {
                title: t('lbl_ranking_system'),
                description: t('lbl_ranking_system_desc')
            },
            {
                title: t('lbl_comps_development'),
                description: t('lbl_comps_development_desc')
            },
            {
                title: t('lbl_organisation_at_highest_level'),
                description: t('lbl_organisation_at_highest_level_desc')
            },
            {
                title: t('lbl_price_rewards'),
                description: t('lbl_price_rewards_desc')
            }
        ]
    }
    //SOCIALMEDIA
    const socialMedia = [
        {
            icon: faFacebook,
            label: 'FaceBook',
            link: 'https://www.facebook.com/profile.php?id=61556152936973&mibextid=LQQJ4d'
        },
        {
            icon: faInstagram,
            label: 'Instagram',
            link: 'https://www.instagram.com/acl_fight?igsh=dThsazc3djVkM2Rk'
        },
    ]
    //NEWS FIRST PAGE
    const newsList: any = [
        {
            title: t('lbl_fen_news_title'),
            image: window.location.origin + '/fen_logo.png',
            content: t('lbl_fen_news_desc')
        },
        {
            title: t('lbl_cfn_news_title'),
            image: 'data:image/png;base64,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',
            content: t('lbl_cfn_news_desc')
        },
        {
            title: t('lbl_ofp_news_title'),
            image: window.location.origin + '/OFP_LOGO.png',
            content: t('lbl_ofp_news_desc')
        },
    ]
    //FIRST EVENT
    const firstEvent: any = {
        mainImage: window.location.origin + '/baner_ACL2.jpeg',
        mainCard: {
            title: t('lbl_main_event'),
            image: window.location.origin + '/karta_2.png',
        },
        fightCards: [
            window.location.origin + '/karta_1.png',
            window.location.origin + '/karta_3.png',
            window.location.origin + '/karta_4.png',
        ],
        tournamentCards: [
            window.location.origin + '/acl_turniej_rozpiska_1.jpg',
            window.location.origin + '/acl_turniej_rozpiska_2.jpg',
            window.location.origin + '/acl_turniej_rozpiska_3.jpg'
        ]
    }


    return {
        firstEvent,
        BuyTicket,
        newsList,
        imagesList,
        handleAnimation,
        upcomingEventOptions,
        upComingEvent,
        socialMedia,
        ourLeague,
        selectedLanguage: language.filter((lang: any) => lang.code === localStorage.getItem('app-lang') ? localStorage.getItem('app-lang') : 'pl')[0] as any,
        language,
        outTeamSections,
        contactValues,
        sponsorMail,
        headerOptions,
        sponsorsData
    }

}

export default usePageContent